import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PayrollGroupData  {
    _originalTypeClassName = "zERP.BO.PayrollGroupData";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PayrollGroupData.translate = translateService;
}
this.DaysWorked = null;
this.DaysInsured = null;
this.TotalSalary = null;
this.Name = null;
this.Description = null;
this.EmployeeContributions = null;
this.Tax = null;
this.EmployeeDeductions = null;
this.AdvanceAmount = null;
this.PayableAmount = null;
this.EmployerContributions = null;
this.EmployerDeductions = null;
this.PayrollGroupDataKey = null;
this._key = this.PayrollGroupDataKey = 0; 
}

static translate: TranslateService;
_key: any;
DaysWorked:any;
DaysInsured:any;
TotalSalary:any;
Name:any;
Description:any;
EmployeeContributions:any;
Tax:any;
EmployeeDeductions:any;
AdvanceAmount:any;
PayableAmount:any;
EmployerContributions:any;
EmployerDeductions:any;
private _PayrollGroupDataKey:any;
get PayrollGroupDataKey(): any {
    return this._PayrollGroupDataKey;
  }
set PayrollGroupDataKey(value: any) {
    this._PayrollGroupDataKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.PayrollGroupDataKey == null || $this.PayrollGroupDataKey == 0;
            }


}